import isHotkey, { isKeyHotkey } from 'is-hotkey';
import isInCodeBlock from '../utils/isInCodeBlock';
import StyleTypes from '../../../types/StyleTypes';
import onTab from './onTab';
import onShiftTab from './onShiftTab';
import onEnter from './onEnter';
import onBackspace from './onBackspace';
import onArrowRight from './onArrowRight';
var isTab = isKeyHotkey('tab');
var isShiftTab = isKeyHotkey('shift+tab');
var isEnter = isKeyHotkey('enter');
var isBackspace = isKeyHotkey('backspace');
/**
 * User is pressing a key in the editor
 */

function onKeyDown(event, editor, next) {
  if (editor.value.selection.isUnset) return next();
  var inCode = isInCodeBlock(editor.value);
  var inInlineCode = editor.value.activeMarks.find(function (mark) {
    return StyleTypes.CODE === mark.type;
  });
  var args = [event, editor, next];

  if (inInlineCode && isHotkey('arrowright', event)) {
    return onArrowRight.apply(void 0, args);
  } // Inside code ?


  if (!inCode) {
    return next();
  } // Add opts in the argument list
  // Select all the code in the block (Mod+a)


  if (isShiftTab(event)) {
    return onShiftTab.apply(void 0, args);
  } else if (isTab(event)) {
    return onTab.apply(void 0, args);
  } else if (isEnter(event)) {
    return onEnter.apply(void 0, args);
  } else if (isBackspace(event)) {
    return onBackspace.apply(void 0, args);
  }

  return next();
}

export default onKeyDown;